import { Box, Flex, Image, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import arrowForward from 'assets/img/icons/arrow-forward-bold.svg';
import ProfitText from 'presentation/components/shared/amount/ProfitText';
import { FontSize } from 'presentation/theme/fontSizes';

interface Props {
  chartImage: string;
  fromAmount: number;
  toAmount: number;
  currency: Currency;
  balanceChange: number;
  balanceChangePercent: number;
  description: string;
  title: string;
}

const StrategyModelIncomeCard: FC<Props> = ({
  chartImage,
  currency,
  toAmount,
  fromAmount,
  balanceChange,
  balanceChangePercent,
  description,
  title,
}) => {
  const chartHeight = 180;

  const currencyText = useCurrencyText();

  return (
    <>
      <GridHeading>{title}</GridHeading>
      <AppCard overflow="hidden">
        <Box
          bgImage="linear-gradient(180deg, #40D9B5 0%, #018949 100%)"
          pos="relative"
          w="100%"
          h={chartHeight}
        >
          <Flex pos="absolute" p="20px" top="0" left="0" flexDir="column">
            <Flex mb="4px">
              <Text
                fontSize="30px"
                fontWeight={700}
                color={Color.OnPrimary}
                mr="10px"
              >
                {currencyText(fromAmount, { symbol: currency.symbol })}
              </Text>
              <Image src={arrowForward} alt="" mr="10px" />
              <Text fontSize="30px" fontWeight={700} color={Color.OnPrimary}>
                {currencyText(toAmount, { symbol: currency.symbol })}
              </Text>
            </Flex>
            <ProfitText
              profitAmount={balanceChange}
              profitPercent={balanceChangePercent}
              currency={currency}
              fontSize={FontSize.sm}
              fontWeight={700}
              isFilled
            />
          </Flex>
          <Image
            pos="absolute"
            w="100%"
            h="140px"
            bottom="0"
            left="0"
            src={chartImage}
          />
        </Box>
        <Text p="20px" pt="10px">
          {description}
        </Text>
      </AppCard>
    </>
  );
};

export default StrategyModelIncomeCard;
